module.exports = __webpack_public_path__ + "img/no-data.67f2b626.png";